"use strict";

var _classCallCheck = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkRelayEventManager = void 0;

var util_1 = require("../util");

var WalletLinkRelayEventManager = /*#__PURE__*/function () {
  function WalletLinkRelayEventManager() {
    _classCallCheck(this, WalletLinkRelayEventManager);

    this._nextRequestId = 0;
    this.callbacks = new Map();
  }

  _createClass(WalletLinkRelayEventManager, [{
    key: "makeRequestId",
    value: function makeRequestId() {
      // max nextId == max int32 for compatibility with mobile
      this._nextRequestId = (this._nextRequestId + 1) % 0x7fffffff;
      var id = this._nextRequestId;
      var idStr = (0, util_1.prepend0x)(id.toString(16)); // unlikely that this will ever be an issue, but just to be safe

      var callback = this.callbacks.get(idStr);

      if (callback) {
        this.callbacks.delete(idStr);
      }

      return id;
    }
  }]);

  return WalletLinkRelayEventManager;
}();

exports.WalletLinkRelayEventManager = WalletLinkRelayEventManager;